/* eslint-disable */

module.exports = {
  ContractNames: {
    Account: 'Account',
    AccountBase: 'AccountBase',
    AccountController: 'AccountController',
    AccountImplementationV1: 'AccountImplementationV1',
    AccountRegistry: 'AccountRegistry',
    BalancesHelper: 'BalancesHelper',
    Controlled: 'Controlled',
    ENSAbstractResolver: 'ENSAbstractResolver',
    ENSAddressResolver: 'ENSAddressResolver',
    ENSController: 'ENSController',
    ENSHelper: 'ENSHelper',
    ENSNameResolver: 'ENSNameResolver',
    ENSPubKeyResolver: 'ENSPubKeyResolver',
    ENSRegistry: 'ENSRegistry',
    ENSReverseRegistrar: 'ENSReverseRegistrar',
    ENSTextResolver: 'ENSTextResolver',
    ERC20Token: 'ERC20Token',
    ExternalAccountRegistry: 'ExternalAccountRegistry',
    Gateway: 'Gateway',
    GatewayRecipient: 'GatewayRecipient',
    Guarded: 'Guarded',
    Initializable: 'Initializable',
    PaymentDepositAccount: 'PaymentDepositAccount',
    PaymentRegistry: 'PaymentRegistry',
    PersonalAccountImplementationV1: 'PersonalAccountImplementationV1',
    PersonalAccountRegistry: 'PersonalAccountRegistry',
    SignatureValidator: 'SignatureValidator',
    WrappedWeiToken: 'WrappedWeiToken',
  },
};
